var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAureaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#070707;stroke:url(#SVGID_1_);stroke-miterlimit:10;}\n\t.st1{fill:#0C0C0B;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:16;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2563,
    y1: 1.9822,
    x2: 21.0988,
    y2: 1.9822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEE25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0178,
    style: {
      stopColor: "#FFE920"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    style: {
      stopColor: "#FED60E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#FDCB04"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F08F34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#E86031"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2312D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.68,11.9L10.68,11.9c-5.48,0-9.92-4.44-9.92-9.92v0c0-5.48,4.44-9.92,9.92-9.92h0 c5.48,0,9.92,4.44,9.92,9.92v0C20.6,7.46,16.16,11.9,10.68,11.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,42.76L21.5,42.76c-11.74,0-21.26-9.52-21.26-21.26v0C0.24,9.76,9.76,0.24,21.5,0.24h0 c11.74,0,21.26,9.52,21.26,21.26v0C42.76,33.24,33.24,42.76,21.5,42.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.23,22.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.97,34.01c-0.18,0-0.35-0.05-0.5-0.16c-0.3-0.22-0.42-0.6-0.31-0.95l8.53-26.25 c0.11-0.35,0.44-0.59,0.81-0.59s0.7,0.24,0.81,0.59l8.53,26.25c0.11,0.35-0.01,0.73-0.31,0.95c-0.3,0.22-0.7,0.22-1,0L18.46,25.8 c-0.38-0.28-0.46-0.81-0.19-1.19c0.28-0.38,0.81-0.46,1.19-0.19l8.96,6.51L21.5,9.66l-6.91,21.28l3.53-2.57 c0.38-0.28,0.91-0.19,1.19,0.19c0.28,0.38,0.19,0.91-0.19,1.19l-5.65,4.1C13.32,33.96,13.14,34.01,12.97,34.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.5,26.66"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureaIcon);
export default __webpack_public_path__ + "static/media/AUREA-ICON.5efa699b788e6a76860ecc5e47d31273.svg";
export { ForwardRef as ReactComponent };